import { ExtendedError } from '../../error';

export const digestResponse = model => {
	if (!model || typeof model !== 'object') {
		return model;
	}

	const resolvedNode = Object.entries(model).reduce((acc, cur) => {
		const [key, value] = cur;
		acc[key] = value?.edges
			? value.edges.map(({ node, ...rest }) => digestResponse({ ...node, ...rest }))
			: digestResponse(value);
		return acc;
	}, model);

	return resolvedNode;
};

/**
 * Handle Shopify user errors
 *
 * @param {object[]} errors
 * @throws {ExtendedError}
 */
export const handleUserErrors = errors => {
	if (errors?.length) {
		throw new ExtendedError({
			code: 'shopify_user_error',
			message: 'User errors occurred during GraphQL execution',
			errors,
		});
	}
};
